import { render, staticRenderFns } from "./MStoreDeleteConfirmation.vue?vue&type=template&id=6ec6c550&"
import script from "./MStoreDeleteConfirmation.vue?vue&type=script&lang=ts&"
export * from "./MStoreDeleteConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports